/*
* fixPlaceholders
* This function will make sure placeholders are acceptable if there is auto complete from the browser
*/
export function fixPlaceholders(args) {
    args = args || {};
    // Special logic to capture if users have information saved in username or password
    var placeholders = $(".fly-up-placeholder");
    for (var ii = 0; ii < placeholders.length; ii++) {
        var placeholder = $(placeholders[ii]);
        placeholder.keyup();
    }

    if (!args.timeout) {
        // More special logic to make sure we capture all the auto complete fields
        setTimeout(function () {
            fixPlaceholders({
                timeout: true
            });
        }, 1000);

        args.focusElement && args.focusElement.focus();
    }
}
